<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4229_9282)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.714279 2.85715C0.714279 1.67368 1.67366 0.714294 2.85714 0.714294H17.1429C18.3263 0.714294 19.2857 1.67368 19.2857 2.85715V6.67921C19.2857 12.3823 15.6363 17.4456 10.2259 19.249C10.0793 19.298 9.92074 19.298 9.77412 19.249C4.36366 17.4456 0.714279 12.3823 0.714279 6.67921V2.85715ZM6.42857 7.85715C5.93545 7.85715 5.53571 8.25689 5.53571 8.75001C5.53571 9.24312 5.93545 9.64287 6.42857 9.64287H13.5714C14.0645 9.64287 14.4643 9.24312 14.4643 8.75001C14.4643 8.25689 14.0645 7.85715 13.5714 7.85715H6.42857Z" fill="#C2BFAC"/>
</g>
<defs>
<clipPath id="clip0_4229_9282">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
